module.exports = __webpack_public_path__ + "static/media/xtimelogo.105f7cb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/AppointmentInfo/xtimelogo.svg
// module id = 1570
// module chunks = 7